module.exports = __webpack_public_path__ + "img/2.98893988.jpg";